import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { createInventoryAdjustment, editInventoryAdjustment, fetchInventoryAdjustmentDetail } from '../../actions/inventoryAdjustments_actions';
import { fetchInventories } from '../../actions/inventoryConverts_actions';

import InventoryAdjustmentForm from '../../components/Inventories/inventoryAdjustmentForm';

const validate = values => {
  const errors = {}
  if (!values.Name) {
      errors.Name = 'Required'
  }
  return errors
}

let inventoryAdjustmentForm = reduxForm({
    form: 'inventoryAdjustmentForm',
    validate
})(InventoryAdjustmentForm);

const selector = formValueSelector('inventoryAdjustmentForm')

function mapStateToProps(state) {
    const toZoneValue = selector(state, 'ToZone');
    const toBinValue = selector(state, 'ToBin');
    const quantityValue = selector(state, 'Quantity');
    const postingDate = selector(state, 'PostingDate');
    const note = selector(state, 'Note');
    return {
        quantityValue,
        toZoneValue,
        toBinValue,
        postingDate,
        note,

        currentInventoryAdjustment: state.inventoryAdjustments.currentInventoryAdjustment,
        currentInventoryAdjustmentDetail: state.inventoryAdjustments.currentInventoryAdjustmentDetail,
        detailIsLoading: state.inventoryAdjustments.detailIsLoading,
        detailError: state.inventoryAdjustments.detailError,
        initialValues: state.inventoryAdjustments.currentInventoryAdjustmentDetail,
        isCreating: state.inventoryAdjustments.isCreating,
        createError: state.inventoryAdjustments.createError,
        created: state.inventoryAdjustments.created,
        isEditing: state.inventoryAdjustments.isEditing,
        editError: state.inventoryAdjustments.editError,
        edited: state.inventoryAdjustments.edited,

        inventories: state.inventoryConverts.inventories,
        vendorIsLoading: state.inventories.isLoading,
        vendorError: state.inventories.error,
        userPermissions: state.auth.userPermissions
    }
}

export default connect(mapStateToProps, { createInventoryAdjustment, editInventoryAdjustment, fetchInventoryAdjustmentDetail, fetchInventories })(inventoryAdjustmentForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inventoryAdjustmentForm.jsx